import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createWeb3Modal } from '@web3modal/wagmi/react'
import { defaultWagmiConfig } from '@web3modal/wagmi/react/config'
import { ConfigProvider } from 'antd'
import { WagmiProvider } from 'wagmi'
import { base, baseSepolia } from 'wagmi/chains'

import ScrollToTop from './component/common/scroll-to-top'
import Main from './component/main/main'
import { AuthProvider } from './context/auth-provider'
import { ENABLE_TESTNET } from './constants'
import PageRoutes from './page-routes'

import './app.scss'
import 'leaflet/dist/leaflet.css'

function App() {
  const queryClient = new QueryClient()
  // 1. Get projectId at https://cloud.walletconnect.com
  const projectId =
    process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID || '5f6c18132c6e21af2b276b34ad0af7ec'
  // 2. Create wagmiConfig
  const metadata = {
    name: process.env.REACT_APP_APP_NAME || '',
    description: 'Web3Modal',
    url: 'https://web3modal.com', // origin must match your domain & subdomain
    icons: ['https://avatars.githubusercontent.com/u/37784886'],
  }
  // const chains = [baseSepolia] as const;
  const chains = ENABLE_TESTNET ? ([baseSepolia] as const) : ([base] as const)
  // console.log('chains', chains)
  const config = defaultWagmiConfig({
    chains, // required
    projectId, // required
    metadata, // required
    enableInjected: false, // Optional - true by default
    enableWalletConnect: true, // Optional - true by default
    enableEIP6963: true, // Optional - true by default
    enableCoinbase: false, // Optional - true by default
  })
  createWeb3Modal({
    wagmiConfig: config,
    projectId,
    enableAnalytics: true, // Optional - defaults to your Cloud configuration
  })
  return (
    <div className="App">
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: '#2b79f7',
                colorSuccess: '#00d415',
              },
            }}
          >
            <AuthProvider>
              <ScrollToTop />
              <Main>
                <PageRoutes />
              </Main>
            </AuthProvider>
          </ConfigProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </div>
  )
}

export default App
